import React from 'react'
import { useTranslation } from 'react-i18next'
import { MapPinIcon } from '@heroicons/react/24/outline'
import { ContractEntity } from '../../../../../../entities'

interface ContractSelectStepProps {
  contracts: ContractEntity[]
  onSelect: (contract: ContractEntity) => void
}

const ContractSelectStep = ({ contracts, onSelect }: ContractSelectStepProps) => {
  const { t } = useTranslation()
  return (
  <div>
    <h3 style={{ fontSize: '1.125rem', fontWeight: 700, color: '#0a0d47', margin: '0 0 4px' }}>
      {t('REPAIR_AND_INQUIRIES.NEW_DAMAGE_REPORT.SELECT_PROPERTY_TITLE')}
    </h3>
    <p style={{ fontSize: '0.875rem', color: '#9ca3af', margin: '0 0 20px' }}>
      {t('REPAIR_AND_INQUIRIES.NEW_DAMAGE_REPORT.SELECT_PROPERTY_SUBTITLE')}
    </p>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {contracts.map((contract) => (
        <button
          key={contract.contractNumber}
          type="button"
          onClick={() => onSelect(contract)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 16,
            width: '100%',
            padding: '18px 20px',
            borderRadius: 12,
            border: '2px solid #e5e7eb',
            background: '#fff',
            cursor: 'pointer',
            textAlign: 'left',
            transition: 'border-color 0.15s, background-color 0.15s',
          }}
          onMouseEnter={(e) => {
            ;(e.currentTarget as HTMLButtonElement).style.borderColor = '#218cda'
            ;(e.currentTarget as HTMLButtonElement).style.backgroundColor = '#f0f8ff'
          }}
          onMouseLeave={(e) => {
            ;(e.currentTarget as HTMLButtonElement).style.borderColor = '#e5e7eb'
            ;(e.currentTarget as HTMLButtonElement).style.backgroundColor = '#fff'
          }}
        >
          <MapPinIcon style={{ width: 24, height: 24, color: '#218cda', flexShrink: 0 }} />
          <div style={{ overflow: 'hidden' }}>
            <p style={{ margin: '0 0 2px', fontSize: '0.9375rem', fontWeight: 600, color: '#111827', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {contract.address}
            </p>
            <p style={{ margin: 0, fontSize: '0.8125rem', color: '#9ca3af' }}>
              {contract.contractNumber}
            </p>
          </div>
        </button>
      ))}
    </div>
  </div>
  )
}

export default ContractSelectStep
